const messages = {
  PLANT_ATTRIBUTES_INVALID: 'Some plant attributes are invalid. Check below for the errors and correct them.',
	UNHANDLED_ERROR: 'Oops! Something went wrong!'
};

export const FormError = ({ errorCode }) => {
	return messages[errorCode] ? messages[errorCode] : messages.UNHANDLED_ERROR;
};
